import angular from 'angular';

import { apiUrls } from './apiUrls';
import requestModule from './request.module';

/**
 * Debounce function call by specified delay.
 *
 * WARNING: this function uses the same closure for all it's invocations. This means
 * that parallel debounce calls in different parts of code will cancel each other.
 */
export type EstGlobalDebounce = (fn: Function, delay: number) => void;

export default angular
  .module('estoffice.common', [requestModule.name])
  .constant('api', apiUrls)
  .constant('image', {
    url: 'http://res.cloudinary.com/estoffice-com/image/upload/c_thumb,h_65,w_65/v1/',
  })
  .factory('debounce', function (): EstGlobalDebounce {
    return (function () {
      let timer;

      return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();
  })
  .filter('to_trusted', [
    '$sce',
    function ($sce) {
      return function (text) {
        return $sce.trustAsHtml(text);
      };
    },
  ])
  .service('find', function (this: { [key: string]: any }) {
    this.byValue = function (
      arraytosearch: any[],
      key: string,
      valuetosearch: unknown,
    ) {
      const index = arraytosearch.findIndex(
        // eslint-disable-next-line eqeqeq
        (item) => item[key] == valuetosearch,
      );

      return index >= 0 ? index : null;
    };
    this.multiValue = function (
      arraytosearch: any[],
      key: string,
      valuetosearch: unknown,
      key2: string,
      valuetosearch2: unknown,
    ) {
      const index = arraytosearch.findIndex(
        // eslint-disable-next-line eqeqeq
        (item) => item[key] == valuetosearch && item[key2] == valuetosearch2,
      );

      return index >= 0 ? index : null;
    };
  });
